import { Container as ProvidersContainer } from './integration_card'
import { ConnectCalendarAccount } from './integration_provider'

export const ConnectCalendar = () => (
  <ProvidersContainer>
    <ConnectCalendarAccount provider="google" />
    <ConnectCalendarAccount provider="outlook" />
    <ConnectCalendarAccount provider="exchange" />
  </ProvidersContainer>
)
